import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      // Don't auto-open if add-to-cart-modal-component is open
      const addToCartModal = document.querySelector('add-to-cart-modal-component');
      if (addToCartModal) {
        // Check wrapper in component first
        let wrapper = addToCartModal.querySelector('.add-to-cart-modal-wrapper');
        // If not found, check in document.body using data-component-id
        if (!wrapper) {
          const componentId = addToCartModal.id;
          if (componentId) {
            wrapper = document.querySelector(`.add-to-cart-modal-wrapper[data-component-id="${componentId}"]`);
          }
        }
        if (wrapper && wrapper.classList.contains('open')) {
          return; // Modal is open, don't auto-open cart drawer
        }
      }
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
